import { type GroupFolderWellKnownName } from 'owa-folders-constants';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

const UnifiedInboxWellKnownNamePrefix = 'UnifiedInbox:';

// Supported folders in Unified Inbox
export const UnifiedInboxSupportedFolders: DistinguishedFolderIdName[] = [
    'inbox',
    'drafts',
    'outbox',
    'archive',
    'sentitems',
    'scheduled',
    'deleteditems',
    'junkemail',
];

// Returns a unique folder ID for a unified inbox folder based on its name
// The folder ID is prefixed with 'UnifiedInbox:' to ensure uniqueness
export function getUniqueUnifiedInboxFolderId(folderName: DistinguishedFolderIdName): string {
    return UnifiedInboxWellKnownNamePrefix + folderName;
}

// Checks if a folder name is for unified inbox
export function isUnifiedInboxFolder(folderName: string): boolean {
    // Instead of just replying on the prefix, also make sure that the folder name
    // part of the string is one of the supported folders in the unified inbox.
    try {
        getUnifiedInboxDistinguishedFolderId(folderName);
        return true;
    } catch {
        return false;
    }
}

// Extracts the distinguished folder ID from a unified inbox folder ID
export function getUnifiedInboxDistinguishedFolderId(
    unifiedInboxFolderId: string
): DistinguishedFolderIdName {
    if (unifiedInboxFolderId.indexOf(UnifiedInboxWellKnownNamePrefix) === 0) {
        const folderName = unifiedInboxFolderId.substring(
            UnifiedInboxWellKnownNamePrefix.length
        ) as DistinguishedFolderIdName;
        if (UnifiedInboxSupportedFolders.includes(folderName)) {
            return folderName;
        }
    }

    throw new Error('Invalid unified inbox folder ID format');
}
